import notifications from "./notifications_bg_grey.svg";
import onebox from "./onebox_bg_grey.svg";
import contacts from "./contacts_bg_grey.svg";
import ringPlans from "./ringPlans_bg_grey.svg";
import widgets from "./widgets_bg_grey.svg";
import search from "./search_bg_grey.svg";
import groups from "./groups_bg_grey.svg";

(window as any).AureliaAssets = {
  notifications,
  onebox,
  contacts,
  ringPlans,
  widgets,
  search,
  groups
};
